var map = {
	"./about.svg": 2758,
	"./alipay.svg": 7549,
	"./arrow_right.svg": 6777,
	"./avatar.svg": 1872,
	"./back.svg": 6506,
	"./bankcard.svg": 3879,
	"./code.svg": 7816,
	"./code2.svg": 8010,
	"./collect.svg": 8327,
	"./copy.svg": 4392,
	"./dynamic.svg": 5798,
	"./edit_arrow.svg": 8993,
	"./feedback.svg": 4394,
	"./female.svg": 2007,
	"./invite.svg": 5183,
	"./male.svg": 2084,
	"./phone.svg": 6425,
	"./pwd.svg": 712,
	"./qa.svg": 6097,
	"./select.svg": 4115,
	"./selected.svg": 8736,
	"./setting.svg": 7029,
	"./shop.svg": 4503,
	"./wechat.svg": 7513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;